/**
 * Customer tokens are namespaced per vendor slug (plan H2). Two salons open in
 * two tabs must not share a session, and signing out of one must not sign the
 * customer out of the other.
 */
const KEY = (slug: string) => `vs.token.${slug}`

interface StoredToken {
  token: string
  /** Epoch ms. Absent means "no expiry known" and the token is kept. */
  expiresAt?: number
}

function read(slug: string): StoredToken | null {
  try {
    const raw = localStorage.getItem(KEY(slug))
    return raw ? (JSON.parse(raw) as StoredToken) : null
  } catch {
    return null
  }
}

export function getToken(slug: string): string | null {
  const stored = read(slug)
  if (!stored) return null
  if (stored.expiresAt && Date.now() >= stored.expiresAt) {
    clearToken(slug)
    return null
  }
  return stored.token
}

export function setToken(slug: string, token: string, expiresInSeconds?: number) {
  const payload: StoredToken = { token }
  if (expiresInSeconds) payload.expiresAt = Date.now() + expiresInSeconds * 1000
  try {
    localStorage.setItem(KEY(slug), JSON.stringify(payload))
  } catch {
    /* private mode — the session simply does not survive a reload */
  }
}

export function clearToken(slug: string) {
  try {
    localStorage.removeItem(KEY(slug))
  } catch {
    /* ignore */
  }
}
